import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { ReceivablesAgingEntity } from "../entities/ReceivablesAgingEntity";

export class GetReceivablesAgingUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<ReceivablesAgingEntity> {
    return this.repository.getReceivablesAging();
  }
}
